<template>
  <div class="small">
          <pie-chart :height="300" :chart-data="CHARTDATA" style="padding: 7px;"></pie-chart>
  </div>
</template>

<script>
  import PieChart from '@/plugins/PieChart.js'

  export default {
      components: {
        PieChart
      },
        data: () => ({
            labels: [],
            credit:[],
            cash:[],
          datacollection:{},
          gradient: null,
      }),
      props: {
        rawdata: {
          type: Array,
          default: function(){ return [] }
        }
      },
    watch: {
      rawdata() {
        this.exportData()
        this.fillData()
        
      }
    },
    computed: {
      CHARTDATA() {
        return this.datacollection
      }, 
      BACKGROUND(){
        return  [
                '#E4B962', '#36A2EB', '#01A698', '#0C4C8A', '#BA55D3',
                '#8C616A', '#F45C51', '#608967', '#8BB5DB', '#686988', '#686988', '#E0FFFA',
                '#FF6384', '#4BC0C0', '#36A2EB', '#0048BA', '#269C69',
                '#9966FF', '#BBF3BB', '#FFF08C', '#0048BA', '#8096BA'
                ]
      }
    },
    methods: {
      exportData() {
         
       this.labels = []
        this.data = []
        for (const item of this.rawdata) {

              this.labels.push(item.label)
              this.data.push(item.count)
          }
      },
      fillData () {
        
        this.datacollection = {
          labels:this.labels,
          datasets: [
            {
              data: this.data,
              backgroundColor: this.BACKGROUND
            }
          ]
        }
       
      }
    }
  }
</script>

<style>
  .small {
    height: 300px;
  }
</style>